import { genComponentStyleHook, type FullToken } from './styleUtil'
import { getBackground, getBorderStyle } from './gradientUtil'

export default genComponentStyleHook(['Tag', 'techTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token
  return {
    [componentCls]: {
      [`&:not(${componentCls}-checkable)`]: {
        '&:before': getBorderStyle(lineWidth),
      },
      [`&${componentCls}-checkable`]: {
        borderColor: 'transparent !important',
        background: token.colorBgContainerDisabled,
        backgroundPosition: `-${lineWidth}px -${lineWidth}px`,
        transition: 'all 0.3s',
        '&-checked': { ...getBackground(lineWidth) },
        '&:hover': { color: token.colorTextLightSolid },
      },
    },
  }
})
